import React from "react";
import PropTypes from "prop-types";
import { ListLink } from "@sunwing/wvi-components";
import { LinkConnector } from "../LinkConnector";

const ListLinkConnector = ({ data }) => {
	if (!data.listLink?.length) {
		return null;
	}

	let linkItemTypeProp;

	switch (data.type) {
		case "Bullet Points":
			linkItemTypeProp = "bullet";
			break;
		case "Numbered":
			linkItemTypeProp = "numbered";
			break;
		case "Grouped by First Letter":
			linkItemTypeProp = "groupedByLetter";
			break;
		case "Chevrons":
		default:
			linkItemTypeProp = "chevron";
			break;
	}

	const listItems = data.listLink.map(item => ({
		href: item.url,
		text: item.linkText || item.url,
		target: item.target,
	}));

	return (
		<ListLink
			list={listItems}
			listType={linkItemTypeProp}
			renderLink={(href, props) => (
				// eslint-disable-next-line react/jsx-props-no-spreading
				<LinkConnector {...props} to={href} />
			)}
		/>
	);
};

ListLinkConnector.propTypes = {
	data: PropTypes.shape({
		listLink: PropTypes.arrayOf(
			PropTypes.shape({
				url: PropTypes.string.isRequired,
				target: PropTypes.oneOf(["_self", "_blank", "_parent", "_top"]),
				linkText: PropTypes.string,
			})
		),
		type: PropTypes.oneOf(["Bullet Points", "Chevrons", "Grouped by First Letter", "Numbered"]),
	}).isRequired,
};

export { ListLinkConnector };
